export enum POST_BODY_TYPE {
  NONE = 'none',
  STRING = 'string',
  JSON = 'json',
  FILE = 'file',
}

export enum BLOCKCHAIN_TYPE {
  ETHEREUM = 'ethereum',
  FABRIC = 'fabric',
}
